import update from 'immutability-helper';
import { useCallback, useEffect, useState } from 'react';
import { Card } from './Card.js';

export const DnDContainer = ({ cards, setCards, onDrop }) => {
  const moveCard = useCallback((dragIndex, hoverIndex) => {
    setCards(prevCards =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      })
    );
  }, []);
  const renderCard = useCallback(
    (card, index) => {
      return (
        <Card
          key={card.id}
          index={index}
          id={card.id}
          component={card.component}
          moveCard={moveCard}
          draggable={card.draggable}
          onDrop={onDrop}
        />
      );
    },
    [onDrop]
  );
  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {cards.map((card, i) => renderCard(card, i))}
      </div>
    </>
  );
};
